import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "rename"];
import { Input } from 'react-login-page';
import { EmailIcon } from "../icons/email.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var Email = props => {
  var {
      keyname = 'email',
      name,
      rename
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var nameBase = name || rename || keyname;
  var key = keyname || name;
  if (!elmProps.children) {
    elmProps.children = EmailIcon;
  }
  return /*#__PURE__*/_jsx(Input, _extends({
    placeholder: "Email",
    spellCheck: false,
    index: 1
  }, elmProps, {
    type: "email",
    name: nameBase,
    keyname: key
  }));
};
Email.displayName = 'Login.Email';